import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { CreateAccessSettingsDTO } from '@app/models/orders';
import Api from '@app/services/api';

interface IParams {
  process_uid: string;
  data: CreateAccessSettingsDTO;
}

export const useCreateProcessAccessSettingsQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ process_uid, data }: IParams) => {
      await Api.orders.createAccessProcessSettings(process_uid, data);
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: commonT.t('dataAddSuccess'),
      });
      await client.invalidateQueries(['getProcessAccessSettings']);
    },
    onError: async () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
      await client.invalidateQueries(['getProcessAccessSettings']);
    },
  });
};
